import { QUEUE, SPECIAL_QUEUE, TO_BE_CONFIRMED_QUEUE } from './queue'
import ITEM from './item'

export const PPS_QUEUE_LAYOUT_SETTING = {
  QUEUE,
  SPECIAL_QUEUE,
  TO_BE_CONFIRMED_QUEUE,
  ITEM
}
